"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFIX = void 0;
exports.PREFIX = 'skey-tix-';
